module.exports = "\n    <h1>404 Error Page #3</h1>\n    <p class=\"zoom-area\"> </p>\n    <section class=\"error-container\">\n      <span>4</span>\n      <span><span class=\"screen-reader-text\">0</span></span>\n      <span>4</span>\n    </section>\n    <div class=\"link-container\">\n     \n    </div>\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/not-found/not-found.component.html
// module id = ./src/app/authentication/not-found/not-found.component.html
// module chunks = main